import styled from '@emotion/styled';
import { breakpoints } from '../../styles/variables/breakpoints';
import { colors } from '../../styles/variables/colors';
import { css } from '@emotion/react';
import { VoteResult } from '../../config/variables';

export const StyledList = styled.ul`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px;
  margin: 0px 0 0 -20px;
`;

export const StyledItem = styled.li`
  padding: 0 20px;
  margin-top: 10px;
  display: flex;
  border-right: 2px solid black;
  align-items: center;

  @media ${breakpoints.width768} {
    border-right: none;
    padding: 0 12px;
  }

  &:last-of-type {
    border-right: none;
  }
`;

export const StyledDetailLink = styled.div`
  text-decoration: underline;
  color: black;

  &:after {
    content: ' >';
  }

  &:hover,
  &:active {
    text-decoration: none;
  }
`;

export const StyledResult = styled.div<{
  result: VoteResult;
  fontSize?: string;
  textTransform?: 'uppercase';
}>`
  font-weight: 600;
  padding: 0 16px;
  margin-top: 10px;
  border-right: 2px solid black;

  @media ${breakpoints.width768} {
    padding: 0 12px;
    border-right: none;
  }

  ${({ result }) =>
    result === VoteResult.Accepted
      ? css`
          color: ${colors.green};
        `
      : css`
          color: ${colors.red};
        `}

  font-size: ${({ fontSize }) => fontSize};
  text-transform: ${({ textTransform }) => textTransform};
`;
